import { useState, useEffect } from 'react';

// No matchMedia (jsdom, very old WebViews): the query simply never matches.
const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * Subscribes to a CSS media query (e.g. Tailwind `md` = '(min-width: 768px)').
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => (canMatch() ? window.matchMedia(query).matches : false));

  useEffect(() => {
    if (!canMatch()) return undefined;
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
